/**
 * Channel tab sorting utility
 *
 * Provides consistent ordering for channel/station tabs across the application.
 * Order: Hot → Germany → Top (2000er) → Relax → Bella → Oldies
 */

const CHANNEL_TAB_SORT_ORDER: Record<string, number> = {
  hot: 1,
  germany: 2,
  top: 3,
  relax: 4,
  bella: 5,
  oldies: 6,
};

/**
 * Sorts channel tabs by priority order.
 * Channels not in the sort order will appear at the end.
 *
 * @param channels - Array of channel objects with optional slug property
 * @returns Sorted array (new array, original unchanged)
 */
export function sortChannelTabsByPriority<T extends { slug?: string | null }>(channels: T[]): T[] {
  return [...channels].sort((a, b) => {
    const orderA = CHANNEL_TAB_SORT_ORDER[a.slug?.toLowerCase() || ""] ?? 999;
    const orderB = CHANNEL_TAB_SORT_ORDER[b.slug?.toLowerCase() || ""] ?? 999;
    return orderA - orderB;
  });
}
